/** An editor content viewer for deviations description */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import BaseViewer from './Base';
import deviationTheme from '../Themes/Viewer/deviation.scss';
const DeviationViewer = (props)=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: 'da-editor-comments'
    }, /*#__PURE__*/ React.createElement(BaseViewer, _object_spread({
        theme: deviationTheme,
        showMediaAlwaysSmall: true,
        fixedParagraph: false
    }, props)));
};
export default DeviationViewer;
